import { AvailableWinDisplayLandscapeProperties } from "../landscape/AvailableWinDisplayLandscapeProperties";
/**
 * AvailableWinDisplayPortraitProperties.ts
 */
export class AvailableWinDisplayPortraitProperties extends AvailableWinDisplayLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.availableWinTextHolderPosition.set(520, 830);
        this.availableWinTextHolderScale.set(1.2, 1.2);
    }
}
//# sourceMappingURL=AvailableWinDisplayPortraitProperties.js.map